<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<TableFuncs>
				<Button type="primary" icon="ios-add-circle-outline" @click="addLightShow=true">新增点灯</Button>
				<Button type="primary" style="margin-left: 20px;" @click="addWish">还愿配置</Button>
				<Button type="primary" style="margin-left: 20px;" @click="getGuide">引导配置</Button>
				<Button type="primary" style="margin-left: 20px;" @click="memberConfigShow">会员配置</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button v-if="row.status=='1'" type="warning" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,0)">停用</Button>
					<Button v-if="row.status=='0'" type="success" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,1)">启用</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addLightShow" :title="addForm.id?'编辑':'新增'" width="900">
			<Form ref="addForm" :model="addForm" :label-width="120">
				<FormItem label="点灯名称" prop="title">
					<Input v-model="addForm.title" placeholder="请输入app名称"></Input>
				</FormItem>
				<FormItem label="名称图片" prop="nameImg">
					<Upload :action="uploadFile" name="file" :on-success="nameImgBack"
						:default-file-list="nameImgList" :data="uploadData" accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传图片</Button>
					</Upload>
				</FormItem>
				<FormItem label="点灯图片" prop="lightImg">
					<Upload :action="uploadFile" name="file" :on-success="lightImgBack"
						:default-file-list="lightImgList" :data="uploadData" accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传图片</Button>
					</Upload>
				</FormItem>
				<FormItem label="对联图片">
					<FormItem label="" prop="leftCoupletImg">
						<Upload :action="uploadFile" name="file" :on-success="leftCoupletImgBack"
							:default-file-list="leftCoupletImgList" :data="uploadData" accept="image/*">
							<Button icon="ios-cloud-upload-outline">左对联</Button>
						</Upload>
					</FormItem>
					<FormItem label="" prop="rightCoupletImg">
						<Upload :action="uploadFile" name="file" :on-success="rightCoupletImgBack"
							:default-file-list="rightCoupletImgList" :data="uploadData" accept="image/*">
							<Button icon="ios-cloud-upload-outline">右对联</Button>
						</Upload>
					</FormItem>
				</FormItem>
				<FormItem label="价格设置" prop="lightImg">
					<table border="1"
						style=" border-collapse: collapse;width: 700px;text-align: center;border-color: #dcdee2;">
						<tr v-for="(item,index) in addForm.feeConfigs" :key="item.timeLong">
							<td style="width: 80px;">
								<Input v-model="item.timeLong" type="number" style="width: 120px;">
								<span slot="append">{{item.timeUnit==1?'天':'年'}}</span>
								</Input>
							</td>
							<td style="width: 80px;">
								<Input v-model="item.totalPrice" type="number" style="width: 150px;">
								<span slot="prepend">价格</span>
								<span slot="append">元</span>
								</Input>
							</td>
							<td style="width: 80px;">
								<Input v-model="item.avgPrice" type="number" style="width: 120px;">
								<span slot="append">元/天</span>
								</Input>
							</td>
							<td style="width: 80px;">
								<Input v-model="item.memberDay" type="number" style="width: 120px;">
								<span slot="append">天会员</span>
								</Input>
							</td>
							<td>
								<i-switch v-model="item.forever" size="large" :true-value="1" :false-value="0">
									<span slot="open">永久</span>
								</i-switch>
							</td>
						</tr>
					</table>
				</FormItem>
				<FormItem label="许愿文案" prop="lightText">
					<Input v-model="addForm.lightText" placeholder="请输入许愿文案"></Input>
				</FormItem>
				<FormItem label="成功文案" prop="successText">
					<Input v-model="addForm.successText" placeholder="请输入成功文案"></Input>
				</FormItem>
				<FormItem label="点灯功效" prop="effectText">
					<Input v-model="addForm.effectText" placeholder="请输入点灯功效"></Input>
				</FormItem>
				<FormItem label="适用人群" prop="targetUserText">
					<Input v-model="addForm.targetUserText" placeholder="请输入适用人群"></Input>
				</FormItem>
				<FormItem label="排序" prop="sortIndex">
					<Input v-model="addForm.sortIndex" type="number" placeholder="数字越大越靠前"></Input>
				</FormItem>
				<FormItem label="状态" prop="status">
					<i-switch v-model="addForm.status=='1'" size="large" @on-change="changeStatus($event,item)">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>
				<FormItem label="投放渠道" prop="useAppList">
					<CheckboxGroup v-model="addForm.useAppList">
						<Checkbox label="1">新华万年历</Checkbox>
						<Checkbox label="2">吉日万年历</Checkbox>
						<Checkbox label="3">神农万年历</Checkbox>
						<Checkbox label="4">中华老黄历</Checkbox>
						<Checkbox label="5">九星万年历</Checkbox>
					</CheckboxGroup>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateLight">确认提交</Button>
			</div>
		</Modal>

		<Modal v-model="addWishShow" title="还愿设置" width="400">
			<table border="1" style=" border-collapse: collapse;width: 300px;text-align: center;border-color: #dcdee2;">
				<tr v-for="(item,index) in wishFeeConfig" :key="item.feeText">					
					<td style="width: 120px;">{{item.feeText}}</td>
					<td>
						<Input v-model="item.price" type="number" style="width: 120px;">
						<span slot="append">元</span>
						</Input>
					</td>
					</td>
				</tr>
			</table>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateWish">确认提交</Button>
			</div>
		</Modal>

		<Modal v-model="addGuideShow" title="引导设置" width="600">
			<Form ref="guideConfig" :model="guideConfig" :label-width="120">
				<FormItem label="引导名称" prop="title">
					<Input v-model="guideConfig.title" placeholder="请输入名称"></Input>
				</FormItem>
				<FormItem label="引导图片" prop="img">
					<Upload :action="uploadFile" name="file" :on-success="guideImgBack"
						:default-file-list="guideImgList" :data="uploadData" accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传图片</Button>
					</Upload>
				</FormItem>
				<FormItem label="展示时间">
					<DatePicker type="datetimerange" v-model="guideConfig.dateRange" format="yyyy年MM月dd日 HH:mm:ss"
						placement="bottom-end" placeholder="请选择" style="width:100%" />
				</FormItem>
				<FormItem label="落地页" prop="linkUrl">
					<Input v-model="guideConfig.linkUrl" placeholder="支持h5/app本身页面/外链"></Input>
				</FormItem>
				<FormItem label="展示频率" prop="showNum">
					<Input v-model="guideConfig.showNum" type="number">
					<span slot="append">次/天</span>
					</Input>
				</FormItem>

			</Form>
			<div slot="footer">
				<Button type="primary" @click="addGuide">确认提交</Button>
			</div>
		</Modal>
		<Modal v-model="addMemberShow" title="会员设置" width="550">
			<table border="1" style=" border-collapse: collapse;width: 500px;text-align: center;border-color: #dcdee2;">
				<tr>
					<td style="width: 120px;">会员时长</td>
					<td>价格</td>
					<td style="width: 120px;">标签</td>
					<td>划线价格</td>
				</tr>
				<tr v-for="(item,index) in memberConfig" :key="item.feeText">
					<td style="width: 120px;">{{item.type==1?'月度':item.type==2?'年度':'永久'}}</td>
					<td>
						<Input v-model="item.amount" type="number" style="width: 120px;">
						<span slot="append">元</span>
						</Input>
					</td>
					<td style="width: 120px;">{{item.feeText}}</td>
					<td>
						<Input v-model="item.originalAmount" type="number" style="width: 120px;">
						<span slot="append">元</span>
						</Input>
					</td>
				</tr>
			</table>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateMember">确认提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition8'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				uploadFile: api.statistics.uploadFile,
				uploadData: {
					filePath: 'img'
				},
				nameImgList: [],
				lightImgList: [],
				leftCoupletImgList: [],
				rightCoupletImgList: [],
				addLightShow: false,
				addWishShow: false,
				guideImgList: [],
				addGuideShow: false,
				addMemberShow:false,
				queryParams: {

				},
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				wishFeeConfig: [{
					id: undefined,
					feeText: '价格1',
					price: undefined,
				}, {
					id: undefined,
					feeText: '价格2',
					price: undefined,
				}, {
					id: undefined,
					feeText: '价格3',
					price: undefined,
				}, {
					id: undefined,
					feeText: '价格4',
					price: undefined,
				}],

				guideConfig: {
					title: '',
					img: '',
					dateRange: [],
					showStartTime: '',
					showEndTime: '',
					linkUrl: '',
					showNum: 1,
				},
				memberConfig: [{
					id: undefined,
					type:1,
					feeText: '按月计费',
					amount: undefined,
					originalAmount:undefined,
				}, {
					id: undefined,
					type:2,
					feeText: '按年计费',
					amount: undefined,
					originalAmount:undefined,					
				}, {
					id: undefined,
					type:3,
					feeText: '会员特价',
					amount: undefined,
					originalAmount:undefined,
				}],
				addForm: {
					id: undefined,
					title: '',
					nameImg:'',
					lightImg: '',
					rightCoupletImg: '',
					leftCoupletImg: '',
					lightText: '',
					successText: '',
					effectText: '',
					targetUserText: '',
					sortIndex: 1,
					status: '1',
					useAppList: [],
					feeConfigs: [{
						id: undefined,
						timeLong: 7,
						timeUnit: 1,
						totalPrice: undefined,
						avgPrice: undefined,
						memberDay:undefined,
						forever:0,
					}, {
						id: undefined,
						timeLong: 30,
						timeUnit: 1,
						totalPrice: undefined,
						avgPrice: undefined,
						memberDay:undefined,
						forever:0,
					}, {
						id: undefined,
						timeLong: 1,
						timeUnit: 2,
						totalPrice: undefined,
						avgPrice: undefined,
						memberDay:undefined,
						forever:0,
					}]
				},
				addRule: {

				}
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: 'ID',
						width: 260,
						key: 'id',
						align: 'center'
					},
					{
						title: '点灯名称',
						key: 'title',
						align: 'center',
						width: 300,
					},
					{
						title: '状态',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.status;
							if (val == '1') {
								name = '启用'
							} else {
								name = '停用'
							}
							return h('span', name)
						}
					}, {
						title: '创建日期',
						key: 'createTime',
						align: 'center',
						width: 200,
					}, {
						title: '操作',
						slot: 'action',
						width: 250,
						align: 'center'
					}

				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			change(){
				
			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.lightPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			addOrUpdateLight() {
				const that = this
				api.statistics
					.addLight(this.addForm)
					.then(res => {
						that.initAdd()
						that.addLightShow = false
						that.refreshData()
					})
					.then(() => {
						that.loading = false
					})
			},
			nameImgBack(response, file, fileList) {
				this.addForm.nameImg = response.data.url
				this.nameImgList = [{
					name: response.data.url,
					url: response.data.url
				}]
			},
			lightImgBack(response, file, fileList) {
				this.addForm.lightImg = response.data.url
				this.lightImgList = [{
					name: response.data.url,
					url: response.data.url
				}]
			},
			leftCoupletImgBack(response, file, fileList) {
				this.addForm.leftCoupletImg = response.data.url
				this.leftCoupletImgList = [{
					name: response.data.url,
					url: response.data.url
				}]
			},
			rightCoupletImgBack(response, file, fileList) {
				this.addForm.rightCoupletImg = response.data.url
				this.rightCoupletImgList = [{
					name: response.data.url,
					url: response.data.url
				}]
			},
			guideImgBack(response, file, fileList) {
				this.guideConfig.img = response.data.url
				this.guideImgList = [{
					name: response.data.url,
					url: response.data.url
				}]
			},
			changeStatus(state, data) {
				this.addForm.status = state ? '1' : '0'
			},
			updateStatus(id, status) {
				const that = this
				api.statistics
					.updateLightStatus({
						'id': id,
						status: status
					})
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = status
							}
						})
					})
			},
			editData(row) {
				const that = this
				api.statistics
					.ligthDetail(row.id)
					.then(res => {
						const result = res.data || {}
						that.addForm = {
							...that.addForm,
							...result
						}
						that.addForm.useAppList = result.useApp.split(",")
						that.nameImgList = [{
							name: result.nameImg,
							url: result.nameImg
						}];
						that.lightImgList = [{
							name: result.lightImg,
							url: result.lightImg
						}];
						that.leftCoupletImgList = [{
							name: result.leftCoupletImg,
							url: result.leftCoupletImg
						}];
						that.rightCoupletImgList = [{
							name: result.rightCoupletImg,
							url: result.rightCoupletImg
						}];
						that.addLightShow = true
					})
			},
			addWish() {
				const that = this
				api.statistics
					.getWishFee()
					.then(res => {
						if (res.data) {
							that.wishFeeConfig = res.data;
						}
						that.addWishShow = true
					})
			},
			addOrUpdateWish() {
				const that = this
				api.statistics
					.addWishFee({
						wishFeeConfigs: this.wishFeeConfig
					})
					.then(res => {
						that.$Message.success('Success!');
						that.addWishShow = false
					})
			},

			getGuide() {
				const that = this
				api.statistics
					.getGuide()
					.then(res => {
						if (res.data) {
							that.guideConfig = res.data;
							that.guideConfig.dateRange=[res.data.showStartTime,res.data.showEndTime]
							that.guideImgList = [{
								name: res.data.img,
								url: res.data.img
							}];
						}
						that.addGuideShow = true
					})
			},
			addGuide() {
				const that = this
				let addGuideConfig = {
					...this.guideConfig
				}
				addGuideConfig.showStartTime = this.GLOBAL.getUTCTime('yyyy-MM-dd hh:mm:ss', this.guideConfig.dateRange[0])
				addGuideConfig.showEndTime = this.GLOBAL.getUTCTime('yyyy-MM-dd hh:mm:ss', this.guideConfig.dateRange[1])
				api.statistics
					.addGuide(addGuideConfig)
					.then(res => {
						that.$Message.success('Success!');
						that.addGuideShow = false
					})
			},
			memberConfigShow(){
				const that = this
				api.statistics
					.memberConfig()
					.then(res => {
						if (res.data) {
							that.memberConfig = res.data;
						}
						that.addMemberShow = true
					})
			},
			addOrUpdateMember(){
				const that = this
				api.statistics
					.addMemberFee({
						memberFees: this.memberConfig
					})
					.then(res => {
						that.$Message.success('Success!');
						that.addMemberShow = false
					})
			},
			initAdd() {
				this.lightImgList = [];
				this.leftCoupletImgList = [];
				this.rightCoupletImgList = [];
				this.addForm = {
					id: undefined,
					title: '',
					lightImg: '',
					rightCoupletImg: '',
					leftCoupletImg: '',
					lightText: '',
					successText: '',
					effectText: '',
					targetUserText: '',
					sortIndex: 1,
					status: '1',
					useAppList: [],
					feeConfigs: [{
						id: undefined,
						timeLong: 7,
						timeUnit: 1,
						totalPrice: undefined,
						avgPrice: undefined,
					}, {
						id: undefined,
						timeLong: 30,
						timeUnit: 1,
						totalPrice: undefined,
						avgPrice: undefined,
					}, {
						id: undefined,
						timeLong: 1,
						timeUnit: 2,
						totalPrice: undefined,
						avgPrice: undefined,
					}]
				}
			}
		}

	}
</script>